import { Box, Typography } from '@mui/material';
import {
    GoogleMap,
    InfoBox,
    Marker,
    useJsApiLoader,
} from '@react-google-maps/api';
import React from 'react';

const containerStyle = {
    width: '100%',
    height: '400px',
};

export const SimpleMap = props => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY,
    });

    const [info, setInfo] = React.useState(false);

    const center = {
        lat: props.center.lat,
        lng: props.center.lng,
    };

    const onMapLoad = map => {
        console.log('map.data: ', map.data);
        // map.data.loadGeoJson('/geo.json')
    };

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={props.zoom}
            onLoad={onMapLoad}
        >
            <Marker position={center} onClick={() => setInfo(!info)}></Marker>
            {info && (
                <InfoBox position={center}>
                    <Box
                        sx={{
                            backgroundColor: '#FFF',
                            boxShadow: '1px 1px 9px -2px rgb(0 0 0 / 20%)',
                            padding: '12px',
                        }}
                    >
                        <Typography>{props.address}</Typography>
                    </Box>
                </InfoBox>
            )}
            {/* Child components, such as markers, info windows, etc. */}
            <></>
        </GoogleMap>
    ) : (
        <></>
    );
};

export default React.memo(SimpleMap);
